export default __webpack_public_path__ + "static/media/LOGO TOP.5011210b.png";